<div [ngClass]="{'form-group': showLabel}" *ngIf="entity && entity.visibleToUser">
  @if(!templateForPermitForm){
  <wm-de-label
    [entity]="entity"
    [for]="entity.templateCode"
    [displayOnly]="true"
    *ngIf="showLabel"
  ></wm-de-label>
  <input
    type="text"
    readonly
    class="form-control-plaintext"
    [id]="entity.templateCode"
    [value]="entity.formattedValue"
  />
  }
  @else {
     <!-- <wm-common-textfield
      [data]="{
      label: entity.label,
      id: entity.templateCode,
      readonly: true,
      value: entity.formattedValue
    }"
      >
    </wm-common-textfield> -->
          <div style="display: flex;flex-direction: column;row-gap: 2px;margin-top: 2px;">
  <!-- Added by Amisha on 03-07-2026.
       Reason: Janus table-layout view screens already render the row label in the left cell,
       so the readonly value cell should only render this label when showLabel is true. -->
  <wm-common-text
    *ngIf="showLabel"
    [data]="{    text: getEntityLabelText(),
}"
    class="entity-text"

  >
  </wm-common-text>
  <wm-common-text
    [data]="{
      text: entity?.formattedValue || entity?.originalValue || ''
    }"
  >
  </wm-common-text>
</div>
  }
</div>
